export const SCHEDULE_ACTIONS = {
  START: "start",
  STOP: "stop"
};

export function getActionsList() {
  return [
    {
      text: "Start",
      value: SCHEDULE_ACTIONS.START
    },
    {
      text: "Stop",
      value: SCHEDULE_ACTIONS.STOP
    }
  ];
}

// keeping this around or we might need it later
export const TEST_STATE = {
  isFetching: false,
  dataIndex: ["/schedules/10111111111", "/schedules/1022222222"],
  dataMap: {
    "/schedules/10111111111": {
      ["@id"]: "/schedules/10111111111",
      ["@type"]: "Schedule",
      id: "10111111111",
      name: "USAGE PROJECT Schedule 1",
      description: "Contains the workstations of USAGE PROJECT.",
      startAt: "2018-11-01 00:00:00",
      endAt: "2018-11-30 23:59:00",
      timezone: "Europe/Riga",
      sunday: false,
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: false,
      actions: [
        {
          value: "start",
          at: "09:00:00"
        },
        {
          value: "stop",
          at: "13:00:00"
        },
        {
          value: "start",
          at: "14:00:00"
        },
        {
          value: "stop",
          at: "18:00:00"
        }
      ],
      resources: [
        "/workstations/428da7e5-dd35-11e8-9935-067822b5e67a",
        "/containers/fd8b921a-dd2d-11e8-9935-067822b5e67a",
        "/workstations/e078fb9c-dd2d-11e8-9935-067822b5e67a"
      ]
    },
    "/schedules/1022222222": {
      ["@id"]: "/schedules/1022222222",
      ["@type"]: "Schedule",
      id: "1022222222",
      name: "Storage Only Wizard Schedule 2",
      description: "Contains the nodes and database of Storage Only Wizard.",
      startAt: "2018-10-05 00:00:00",
      endAt: "2018-11-15 23:59:00",
      timezone: "Europe/Lisbon",
      sunday: true,
      wednesday: false,
      thursday: false,
      saturday: true,
      actions: [
        {
          value: "start",
          at: "09:30:00"
        },
        {
          value: "stop",
          at: "19:30:00"
        }
      ],
      resources: [
        "/nodes/0f0b40dd-dc64-11e8-9935-067822b5e67a",
        "/nodes/a61cf037-dc63-11e8-9935-067822b5e67a",
        "/databases/f43a3027-dc63-11e8-9935-067822b5e67a"
      ]
    }
  }
};
